import { Link } from "@inertiajs/react"

export function Footer() {
  return (
    <footer className="border-t border-border broken-border">
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-muted-foreground">
          <p className="font-mono glitch-subtle" data-text={`© ${new Date().getFullYear()} Broken Sounds`}>
            © {new Date().getFullYear()} Broken Sounds
          </p>
          <nav className="flex gap-6">
            <Link href="/terms" className="hover:text-foreground transition-colors glitch-hover">
              Terms
            </Link>
            <Link href="/privacy" className="hover:text-foreground transition-colors glitch-hover">
              Privacy
            </Link>
            <Link href="/dmca" className="hover:text-foreground transition-colors glitch-hover">
              DMCA
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  )
}
